import * as yup from 'yup';

const USZipCodesRegExp = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const validateContactInfoForm = yup.object({
  addressline1: yup.string().max(150, 'Cannot exceed 150 characters'),
  addressline2: yup.string().max(150, 'Cannot exceed 150 characters'),
  city: yup.string().max(30, 'Cannot exceed 30 characters'),
  state: yup.string(),
  province: yup.string().max(20, 'Cannot exceed 20 characters'),
  country: yup.string(),
  zip: yup
    .string()
    .when('country', {
      is: 'United States',
      then: yup.string().matches(USZipCodesRegExp, 'US Zip Code is not valid')
    })
    .max(20, 'Cannot exceed 20 digits'),
  secondaryAddressline1: yup.string().max(80, 'Cannot exceed 80 characters'),
  secondaryAddressline2: yup.string().max(80, 'Cannot exceed 80 characters'),
  secondaryCity: yup.string().max(30, 'Cannot exceed 30 characters'),
  secondaryState: yup.string(),
  secondaryProvince: yup.string().max(20, 'Cannot exceed 20 characters'),
  secondaryCountry: yup.string(),
  secondaryZip: yup
    .string()
    .when('secondaryCountry', {
      is: 'United States',
      then: yup.string().matches(USZipCodesRegExp, 'US Zip Code is not valid')
    })
    .max(20, 'Cannot exceed 20 digits'),
  email: yup.string().email('Email must be a valid email').required('Email is a required field'),
  email2: yup.string().email('Email must be a valid email'),
  phone: yup.string(),
  phone2: yup.string(),
  phone3: yup.string(),
  phone4: yup.string(),
  languages: yup.array().when('needInterpreter', {
    is: 'Y',
    then: yup
      .array()
      .required(
        'Language field must have at least 1 items when Require an interpreter below is checked'
      )
  })
});
